import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { environment } from 'environments/environment';
import { user } from 'app/mock-api/common/user/data';
@Injectable()
export class AuthService {
    token: JSON;
    // token = AuthUtils._decodeToken;

    private _authenticated: boolean = false;

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string) {
        sessionStorage.setItem('accessToken', token);
    }

    get accessToken(): string {
        return sessionStorage.getItem('accessToken') ?? '';
    }

    set refreshToken(token: string) {
        sessionStorage.setItem('refreshToken', token);
    }

    get refreshToken(): string {
        return sessionStorage.getItem('refreshToken') ?? '';
    }
    set sessionId(token: string) {
        sessionStorage.setItem('sessionId', token);
    }

    get sessionId(): string {
        return sessionStorage.getItem('sessionId') ?? '';
    }

    set usrRoles(token: string) {
        sessionStorage.setItem('userRoles', token);
    }

    get usrRoles(): any {
        return JSON.parse(sessionStorage.getItem('userRoles'));
    }

    set idToken(token: string) {
        sessionStorage.setItem('idToken', token);
    }

    get idToken(): string {
        return sessionStorage.getItem('idToken') ?? '';
    }

    get orgId(): string {
        let orgId = sessionStorage.getItem('orgId');
        console.log("Auth Service Called", orgId);
        return orgId;
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string, pltfNm: string): Observable<any> {
        let params = new HttpParams();
        params = params.append('pltfNm', pltfNm)
        return this._httpClient.post(environment.seApiURL + `/identity-manager/user-cred/forgetPassword/${email}`, {}, { params: params });
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPswdByUsr(data: any): Observable<any> {
        // return this._httpClient.post('api/auth/reset-password', password);
        return this._httpClient.put(environment.seApiURL + '/identity-manager/user-cred/user/password', data);
    }
    resetPswdByAdmin(data: any): Observable<any> {
        // return this._httpClient.post('api/auth/reset-password', password);
        return this._httpClient.put(environment.seApiURL + '/identity-manager/user-cred/admin/password', data);
    }

    resetForgetPswd(data: any) {
        console.log("In service");
        return this._httpClient.post(environment.seApiURL + `/identity-manager/user-cred/resetForgetPassword`, data).pipe(
            map((response) => {
                return response;
            }),
            catchError(err => {
                return of(err);
            })
        );
    }

    validateForgotPswdToken(data: any) {
        return this._httpClient.get(environment.seApiURL + `/identity-manager/user-cred/validateForgetPassword/${data}`);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { userId: string; password: string }): Observable<any> {
        // Throw error, if the user is already logged in
        if (this._authenticated) {
            return throwError('User is already logged in.');
        }

        // API call to authenticate user
        return this._httpClient.post(environment.seApiURL + '/identity-manager/login', credentials).pipe(
            switchMap((response: any) => {
                // Store the tokens as received without decoding
                this.accessToken = response.accessToken;
                this.refreshToken = response.refreshToken;
                this.idToken = response.idToken;
                this.sessionId = response.sessionId;

                // // If the tokens are hardcoded and not JWT, skip decoding
                // sessionStorage.setItem('accessToken', this.accessToken);
                // sessionStorage.setItem('refreshToken', this.refreshToken);
                // sessionStorage.setItem('idToken', this.idToken);
                // sessionStorage.setItem('sessionId', this.sessionId);

                this.token =  (AuthUtils._decodeToken(this.accessToken));
                console.log('token = ', this.token);
                sessionStorage.setItem('usr',JSON.stringify(this.token))
                let data = JSON.parse(sessionStorage.usr);
                console.log('data = ',data);
                this.usrRoles = JSON.stringify(data['custom:role']);
                sessionStorage.setItem('usrId',data['custom:usrId']);
                sessionStorage.setItem('orgId',data['custom:org']);

                // Set additional session information
                // sessionStorage.setItem('usr', JSON.stringify({ role: 'defaultRole', userId: '12345' })); // Placeholder values
                // sessionStorage.setItem('activeRole', response.role);
                sessionStorage.setItem('activeRole',data['custom:role'])

                // Set the authenticated flag to true
                this._authenticated = true;

                // Set the user on the user service (if required)
                this._userService.user = response.user;

                // Return a new observable with the response
                return of(response);
            })
        );
    }



    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any> {
        // Sign in using the token
        return this._httpClient.post('api/auth/sign-in-with-token', {
            accessToken: this.accessToken
        }).pipe(
            catchError(() =>

                // Return false
                of(false)
            ),
            switchMap((response: any) => {

                // Replace the access token with the new one if it's available on
                // the response object.
                //
                // This is an added optional step for better security. Once you sign
                // in using the token, you should generate a new one on the server
                // side and attach it to the response object. Then the following
                // piece of code can replace the token with the refreshed one.
                if (response.accessToken) {
                    this.accessToken = response.accessToken;
                }

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response.user;

                // Return true
                return of(true);
            })
        );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any> {
        // Remove the access token from the local storage
        sessionStorage.removeItem('accessToken');

        // Set the authenticated flag to false
        this._authenticated = false;

        // Return the observable
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: any): Observable<any> {
        // return this._httpClient.post('http://192.168.1.7/identity-manager/user-cred', user);
        return this._httpClient.post(environment.seApiURL + '/identity-manager/user-cred', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any> {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean> {
        // Check if the user is logged in
        if (this._authenticated) {
            return of(true);
        }

        // Check the access token availability
        if (!this.accessToken) {
            return of(false);
        }

        // Check the access token expire date
        if (AuthUtils.isTokenExpired(this.accessToken)) {
            return of(false);
        }

        // If the access token exists and it didn't expire, sign in using it
        return this.signInUsingToken();
    }

    getRctrId(usrId) {
        // let rctrId = sessionStorage.getItem('rctrId');
        return this._httpClient.get(environment.seApiURL + `/recruiters?search=usrId==${usrId}`);
    }

    isSvcReqAval(usrId) {
        return this._httpClient.get(environment.seApiURL + `/service-requests/isCheckSvcRqstAvail/${usrId}`);
    }

    getCndtId(usrId) {
        // let rctrId = sessionStorage.getItem('rctrId');
        return this._httpClient.get(environment.seApiURL + `/candidates?search=usrId==${usrId}`);
    }
}
